module.exports = __webpack_public_path__ + "img/cambio.ff61ea37.svg";